import { Shipment } from "pwapi";

import { PWAction } from "shared/utils/redux";

import { SHIPMENTS } from "app/actions/shippingActions";

const shipmentReducer = (
  state: Shipment | null = null,
  action: PWAction
): Shipment | null => {
  switch (action.type) {
    case SHIPMENTS.GET.REQUEST:
      return null;
    case SHIPMENTS.GET.SUCCESS:
      return action.payload.response;
    case SHIPMENTS.GET.ERROR:
      return null;
  }

  return state;
};

export default shipmentReducer;
